// extracted by mini-css-extract-plugin
module.exports = {"companyHeader":"CompanyHeader_companyHeader__NqrQH","companyHeaderInfos":"CompanyHeader_companyHeaderInfos__9dTz0"};